import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import './ModifCartePanel.css';
import { useT } from '../i18n';

const ModifCartePanel = ({
  textSize, setTextSize, textColor, setTextColor,
  message, setMessage,
  lineHeight, setLineHeight, textHeight, setTextHeight,
  onSubmit, isSubmitting, buttonText
}) => {
  const t = useT('scratch-card');

  // Fonction pour convertir les <br /> en \n lors du changement du textarea
  const handleMessageChange = (e) => {
    setMessage(e.target.value);  // Stocke directement le texte avec des sauts de ligne \n
  };

  return (
    <div className="modif-carte-panel">
      <h3>{t('scratch-card.panel.title')}</h3>
      <p className="info">
      <InfoOutlinedIcon fontSize="small" />
        {t('scratch-card.panel.hint')}</p>
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label htmlFor="textSize">{t('scratch-card.panel.textSize', { size: textSize })}</label>
          <input
            id="textSize"
            type="range"
            value={textSize}
            onChange={(e) => setTextSize(Number(e.target.value))}
            min="10"
            max="100"
            step="1"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label htmlFor="textColor">{t('scratch-card.panel.textColor')}</label>
          <input
            id="textColor"
            type="color"
            value={textColor}
            onChange={(e) => setTextColor(e.target.value)}
            className="form-control"
          />
        </div>

        {/* Utilisation d'un textarea pour le message */}
        <div className="form-group">
          <label htmlFor="message">{t('scratch-card.panel.message')}</label>
          <p className="alerte">
            <WarningAmberOutlinedIcon fontSize="small" />
            {t('scratch-card.panel.emojiWarning')}</p>
          <textarea
            id="message"
            value={message.replace(/<br\s*\/?>/g, '\n')}  // Remplacer les <br /> par \n pour afficher dans textarea
            onChange={handleMessageChange}  // Utilisation de handleMessageChange pour mettre à jour le message
            className="form-control"
            rows="4"  // Hauteur du textarea (4 lignes visibles)
          />
        </div>

        <div className="form-group">
          <label htmlFor="textHeight">{t('scratch-card.panel.textHeight', { value: textHeight })}</label>
          <input
            id="textHeight"
            type="range"
            value={textHeight}
            onChange={(e) => setTextHeight(Number(e.target.value))}
            min="-100"
            max="100"
            step="1"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label htmlFor="lineHeight">{t('scratch-card.panel.lineHeight', { value: lineHeight })}</label>
          <input
            id="lineHeight"
            type="range"
            value={lineHeight}
            onChange={(e) => setLineHeight(Number(e.target.value))}
            min="0"
            max="100"
            step="0.1"
            className="form-control"
          />
        </div>

        <button type="submit" className="submit-button" disabled={isSubmitting}>
          {buttonText}
        </button>
      </form>
    </div>
  );
};

export default ModifCartePanel;
